module.exports = __webpack_public_path__ + "img/source04_05.f22a0114.png";